import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { authAPI } from '../../services/api';
import { Button, Input, Alert } from '../../components/common';
import './ProfilePage.css';

const ProfilePage = () => {
  const { user, updateUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const [formData, setFormData] = useState({
    real_name: user?.real_name || '',
    phone: user?.phone || '',
    avatar: user?.avatar || '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setMessage({ type: '', text: '' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await authAPI.updateProfile(formData);
      updateUser(response.data);
      setMessage({ type: 'success', text: '个人信息更新成功' });
    } catch (err) {
      const errorMsg = err.response?.data?.detail || '更新失败，请稍后重试';
      setMessage({ type: 'error', text: errorMsg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="profile-page">
      <div className="page-header">
        <h1>个人资料</h1>
        <p>管理您的个人信息</p>
      </div>

      <div className="profile-content">
        <div className="profile-sidebar">
          <div className="profile-avatar-section">
            <div className="profile-avatar-large">
              {user?.avatar ? (
                <img src={user.avatar} alt="头像" />
              ) : (
                <span>{(user?.real_name || user?.username || 'U')[0].toUpperCase()}</span>
              )}
            </div>
            <h3 className="profile-name">{user?.real_name || user?.username}</h3>
            <p className="profile-role">
              {user?.roles_info?.map(r => r.name).join('、') || '普通用户'}
            </p>
          </div>

          <div className="profile-meta">
            <div className="meta-item">
              <span className="meta-label">工号</span>
              <span className="meta-value">{user?.employee_id || '-'}</span>
            </div>
            <div className="meta-item">
              <span className="meta-label">部门</span>
              <span className="meta-value">{user?.department_name || '-'}</span>
            </div>
            <div className="meta-item">
              <span className="meta-label">职位</span>
              <span className="meta-value">{user?.position || '-'}</span>
            </div>
            <div className="meta-item">
              <span className="meta-label">注册时间</span>
              <span className="meta-value">
                {user?.date_joined ? new Date(user.date_joined).toLocaleDateString('zh-CN') : '-'}
              </span>
            </div>
          </div>
        </div>

        <div className="profile-main">
          <div className="profile-card">
            <h3 className="card-title">编辑资料</h3>

            {message.text && (
              <Alert
                type={message.type}
                message={message.text}
                onClose={() => setMessage({ type: '', text: '' })}
              />
            )}

            <form className="profile-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <Input
                  label="用户名"
                  value={user?.username || ''}
                  disabled
                  hint="用户名不可修改"
                />
                <Input
                  label="邮箱"
                  value={user?.email || ''}
                  disabled
                  hint="邮箱不可修改"
                />
              </div>

              <div className="form-row">
                <Input
                  name="real_name"
                  label="真实姓名"
                  placeholder="请输入真实姓名"
                  value={formData.real_name}
                  onChange={handleChange}
                />
                <Input
                  name="phone"
                  label="手机号"
                  placeholder="请输入手机号"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>

              <Input
                name="avatar"
                label="头像URL"
                placeholder="请输入头像图片URL"
                value={formData.avatar}
                onChange={handleChange}
              />

              <div className="form-actions">
                <Button type="submit" loading={loading}>
                  保存修改
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;

